import e from "./typeof.js";
import t from "./toPrimitive.js";
//#region \0@oxc-project+runtime@0.151.0/helpers/esm/toPropertyKey.js
function n(n) {
	var r = t(n, "string");
	return e(r) == "symbol" ? r : r + "";
}
//#endregion
export { n as default };
